import { Helmet } from "react-helmet";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

function GradesPage(){
  const grades = [
    { label: "LKG", slug: "lkg", icon: "🧩" },
    { label: "UKG", slug: "ukg", icon: "🖍️" },
    { label: "Class 1", slug: "class-1", icon: "🔢" },
    { label: "Class 2", slug: "class-2", icon: "📕" },
    { label: "Class 3", slug: "class-3", icon: "🧮" },
    { label: "Class 4", slug: "class-4", icon: "📚" },
    { label: "Class 5", slug: "class-5", icon: "✏️" },
    { label: "Class 6", slug: "class-6", icon: "🌍" },
    { label: "Class 7", slug: "class-7", icon: "🔬" }
  ];
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const subjectSlug = searchParams.get("subject");

  return(
    <div
      style={{
        minHeight: "100vh",
        padding: "28px",
        background: "#F7FAFF"
      }}
    >
      <Helmet>
        <title>Grades – PracticeNest</title>
        <meta
          name="description"
          content="Select a class to view worksheets for LKG, UKG, and Classes 1 to 7."
        />
        <link rel="canonical" href="https://practicenest.in/grades" />
      </Helmet>
      <div style={{maxWidth: "1000px", margin: "0 auto"}}>
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "18px"}}>
          <button
            onClick={() => navigate(-1)}
            style={{
              padding: "6px 10px",
              borderRadius: "10px",
              border: "1px solid #cfd8e3",
              background: "#fff",
              cursor: "pointer"
            }}
          >
            ←
          </button>
          <Link to="/" style={{textDecoration: "none", fontWeight: "600"}}>Home</Link>
        </div>
        <h1 style={{fontSize: "32px", textAlign: "center", marginBottom: "24px"}}>Choose Your Class</h1>

        <div style={{display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "16px"}}>
          {grades.map((g) => (
            <Link
              key={g.slug}
              to={subjectSlug ? `/worksheets/${g.slug}/${subjectSlug}` : `/grades/${g.slug}`}
              style={{
                textDecoration: "none",
                color: "inherit",
                background: "#fff",
                padding: "16px",
                borderRadius: "14px",
                border: "1px solid #e6eef7",
                boxShadow: "0 6px 14px rgba(0,0,0,0.05)",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "12px"
              }}
            >
              <div style={{display: "flex", alignItems: "center", gap: "12px"}}>
                <div style={{
                  width: "44px",
                  height: "44px",
                  borderRadius: "50%",
                  background: "#EEF5FF",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "22px"
                }}>
                  {g.icon}
                </div>
                <div style={{fontWeight: "700"}}>{g.label}</div>
              </div>
              <div style={{fontSize: "18px", color: "#9aa7b2"}}>›</div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GradesPage;
